import { useEffect, useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { useLanguage } from "../hooks/useLanguage";

export default function ScrollControls() {
  const { lang } = useLanguage();
  const labels = lang === 'EN' ? { up: 'Back to top', down: 'Scroll to bottom' } : { up: 'Наверх', down: 'Вниз' };
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);

  const updateState = () => {
    const scrollY = window.scrollY;
    const clientHeight = window.innerHeight;
    const scrollHeight = document.documentElement.scrollHeight;

    setCanScrollUp(scrollY > 100);
    setCanScrollDown(scrollY + clientHeight < scrollHeight - 100);
  };

  useEffect(() => {
    updateState();
    window.addEventListener("scroll", updateState);
    window.addEventListener("resize", updateState);
    return () => {
      window.removeEventListener("scroll", updateState);
      window.removeEventListener("resize", updateState);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
  };

  if (!canScrollUp && !canScrollDown) return null;

  return (
    <div className="scroll-controls" role="group" aria-label={lang === 'EN' ? 'Page navigation' : 'Навигация по странице'}>
      {canScrollUp && (
        <button
          type="button"
          onClick={scrollToTop}
          className="scroll-control-button"
          title={labels.up}
          aria-label={labels.up}
        >
          <ChevronUp size={24} />
        </button>
      )}
      {canScrollDown && (
        <button
          type="button"
          onClick={scrollToBottom}
          className="scroll-control-button"
          title={labels.down}
          aria-label={labels.down}
        >
          <ChevronDown size={24} />
        </button>
      )}
    </div>
  );
}
